import React from 'react';
import { Link } from 'react-router-dom';
import { Palette } from 'lucide-react';

export default function ProposalDesignPage() {
  return (
    <div className="page-container">
      <section className="page-header section-dark">
        <div className="section-content">
          <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto' }}>
            <Palette size={56} style={{ color: 'var(--gold-primary)', marginBottom: '24px' }} />
            <h1 style={{ fontSize: '48px', marginBottom: '24px' }}>Proposal Design</h1>
            <p style={{ fontSize: '20px', color: 'var(--text-secondary)' }}>
              Professional visual design and formatting that makes your proposals stand out while maintaining readability and regulatory compliance.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-light">
        <div className="section-content">
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ marginBottom: '24px' }}>Elevate Your Proposal Design</h2>
            <Link to="/contact" className="btn-primary">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
